export function createRng(seed) {
    let state = seed >>> 0;
    const next = () => {
        state = (state + 0x6d2b79f5) >>> 0;
        let t = state;
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
    return {
        next,
        int: (min, max) => min + Math.floor(next() * (max - min + 1)),
        pick: (items) => {
            if (items.length === 0)
                throw new Error('pick() sobre lista vacía');
            return items[Math.floor(next() * items.length)];
        },
        chance: (probability) => next() < probability,
    };
}
/** Semilla aleatoria de 31 bits (cabe en un INTEGER/BIGINT de PostgreSQL). */
export function randomSeed() {
    return Math.floor(Math.random() * 0x7fffffff);
}
/** Selección ponderada: `weights[i]` es el peso de `items[i]`. */
export function weightedPick(rng, items, weights) {
    const total = weights.reduce((sum, w) => sum + Math.max(0, w), 0);
    if (total <= 0)
        return rng.pick(items);
    let roll = rng.next() * total;
    for (let i = 0; i < items.length; i++) {
        roll -= Math.max(0, weights[i] ?? 0);
        if (roll < 0)
            return items[i];
    }
    return items[items.length - 1];
}
//# sourceMappingURL=random.js.map